import type { Locale } from '@/i18n/types'

function formatDate(dateTime_: unknown, locale: Locale = 'de') {
  const dateTime =
    dateTime_ instanceof Date ? dateTime_ : typeof dateTime_ === 'string' ? new Date(dateTime_) : undefined
  if (!dateTime) return ''
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  }).format(dateTime)
}

export default formatDate
